import { Stack, Text } from "@certn/cascadia";
import { Divider, TextAreaFormikField } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { CUSTOM_INSTRUCTIONS_MAX_LENGTH } from "./customInstructionsConstants";

interface CustomInstructionsFormSectionProps {
  fieldName: string;
  defaultInstructionsPlaceholder: string;
}

export function CustomInstructionsFormSection({
  fieldName,
  defaultInstructionsPlaceholder,
}: CustomInstructionsFormSectionProps) {
  const { t } = useTranslation();

  return (
    <>
      <Divider />
      <Stack gap="space-0">
        <Text style="form/section-heading">{t("Custom instructions")}</Text>
        <Text style="form/body-secondary">
          {t(
            "Customize the instructions shown to applicants for this section. If left blank, the default description will be shown. Note: custom instructions will not be translated."
          )}
        </Text>
      </Stack>
      <TextAreaFormikField
        name={fieldName}
        label={t("Instructions")}
        testID="custom-instructions"
        maxLength={CUSTOM_INSTRUCTIONS_MAX_LENGTH}
        placeholder={defaultInstructionsPlaceholder}
        minHeight={100}
      />
    </>
  );
}
